import { actionTypes } from 'redux/actions/admin'
import { Job } from 'redux/actions/admin'
export interface IUserObject {
  expo_push_token?: string
  first_name: string
  last_name: string
  uid: string
  locale: string
  profile_img_url?: string
}
export interface IAdminState {
  isFetching: boolean
  activeJobs: Job[]
  inactiveJobs: Job[]
}

export const initialState: IAdminState = {
  isFetching: false,
  activeJobs: [],
  inactiveJobs: [],
}

const AdminReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      }
    case actionTypes.SET_ACTIVE_JOBS:
      return {
        ...state,
        activeJobs: action.payload,
      }
    case actionTypes.SET_INACTIVE_JOBS:
      return {
        ...state,
        inactiveJobs: action.payload,
      }
    case actionTypes.UPDATE_ACTIVE_JOB:
      return {
        ...state,
        activeJobs: state.activeJobs.map((job) => (job.job_id === action.payload.job_id ? action.payload : job)),
      }
    case actionTypes.UPDATE_INACTIVE_JOB:
      return {
        ...state,
        inactiveJobs: state.inactiveJobs.map((job) => (job.job_id === action.payload.job_id ? action.payload : job)),
      }
    default:
      return state
  }
}

export default AdminReducer
